import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-mouse-open",
  "use": "foquz-icon-mouse-open-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-mouse-open\"><path d=\"M5 13H3a2 2 0 01-2-2V3a2 2 0 012-2h8a2 2 0 012 2v2M9.991 9.991L13 8.294 5 5l3.294 8 1.697-3.009zm0 0L13 13\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol